import { render, staticRenderFns } from "./WhoWeAre.vue?vue&type=template&id=00815fdc&"
import script from "./WhoWeAre.vue?vue&type=script&lang=js&"
export * from "./WhoWeAre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports